import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";

export const AuthenticationField = ({autoComplete="off", label,errors,register, name, type = "text", placeholder, icon }) => {
  const isPasswordField = type === "password";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div>
      <div className="relative">
      <input
        autoComplete={"new-password"}
        {...register(name)}
        type={isPasswordField ? (showPassword ? "text" : "password") : type}
        name={name}
        id={name}
        placeholder={placeholder}
        className={`w-full h-[50px] rounded-[7px] border-[1px] border-[solid] border-clientMidGrey bg-clientMidWhiteSmoke pl-[54px] mt-[25px]${isPasswordField ? " pr-10" : ""}`}
      ></input>
      <img
        src={icon}
        alt="UserIcon"
        className="w-[24px] h-[24px] m-[0] rounded-none absolute bottom-[13px] left-[15px]"
      ></img>
      {isPasswordField && (
        <button
          type="button"
          className="absolute bottom-[13px] right-[15px] flex items-center"
          onClick={() => setShowPassword((prev) => !prev)}
          aria-label="toggle password visibility"
        >
          {showPassword ? (
            <FiEyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" />
          ) : (
            <FiEye className="h-5 w-5 text-gray-400 hover:text-gray-600" />
          )}
        </button>
      )}
    </div>
    {errors[name] && <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>}
    </div>
  );
};
